import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as JSZip from 'jszip';
import { ToastrService } from 'ngx-toastr';
import { DeleteTemplateModal } from './delete-template-modal.component';
import { TemplatesService } from './templates.service';
import { UpdateTemplateModal } from './update-template-modal.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import * as FileSaver from 'file-saver';
import { auto } from '@popperjs/core';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { TemplateCreationComponent } from '../template-creation/template-creation.component';
import { QuestionScanningComponent } from '../question-scanning/question-scanning.component';
import { SearchTemplateModel } from 'src/app/Models/SearchTemplateModel';
import { ViewfileComponent } from 'src/app/components/viewfile/viewfile.component';
import { environment } from 'src/environments/environment';
import { RatingModalComponent } from '../rating-modal/rating-modal.component';
import { ViewReviewModalComponent } from '../view-review-modal/view-review-modal.component';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { ExcelService } from 'src/app/services/excel-service.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TemplatesComponent implements OnInit {
  mainUrl = environment.apiUrl;
  public checked:boolean = false;
  public radioSelected:string;
  public selected:string[] = [];
  public mostDownloadedTemplates: any;
  public mostRatedTemplates: any;
  public mostViewedTemplates: any;
  public templates: any = [];
  public serviceLines: any = [];
  public competency: any = [];
  public templatesForSideNav: any = []
  public serviceLinesForDropDown: any = []
  public dataLoaded: boolean = true;
  searchFilters: any;
  public rightSideNav: boolean
  public searchTemplateModel = new SearchTemplateModel()
  role: string;
  superAdminAndAdmin: boolean;
  adminSuperAdminLeadership: boolean;
  constructor(private router: Router,
    public dialog: MatDialog,
    private _service: TemplatesService,
    private _proposalService: AddProposalService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private templateService:TemplatesService,
    private excel: ExcelService,
  ) { }
  selectedTemplateCount: number = 0;
  currentDocuments: any = [];
  uploadedDocuments: any = []
  ratings: any = []
  selectedTemplate: number;
  selectedTemplateName: string;
  selectedDocsForDownload = [];
  templateResponse: any = [];
  templateResponseForTable: any = [];
  useremail: any
  existingUser: any;
  empId: number;

  templateModel: any = [];
  selectAll = false;
  canDownload = false;
  searchText: string = '';
  showTemplates: boolean = true;
  subTemplate: any = [];
  loading:boolean = false;
  selectedImage = "url('../../../assets/images/File_closed.svg')";
  defaultImage = "url('../../../assets/images/File_open.svg')";
  hoverImage = "url('../../../assets/images/File_closed_hover.svg')";
  mostDownloadedProjects: void;
  mostViewedProjects: void;
  searchResultsViewFlag = false
  throttle = 1;
  distance = 1000;
  size = 8;
  from = 0;
  docSize = 3
  docFrom = 0;
  artifactoryView = 'card';
  displayedColumns: string[] = [
    'fileName',
    'subCategoryTemplate',
    'templateName',
    'templateDescription',
    'templateTags',
    'contactPerson',
    'actions'
  ];
  uploadedDocumentsForTable: any = [];
  @ViewChild('divClick') divClick: ElementRef;
  public categoryList = [
    {
      name: "Solutioning Templates",
      iconUrl: "Case_studies.svg",
      description:
        " The Solutions Template is a structured approach to describing solutions to problems.",
      data: "Solutioning Templates",
    },
    {
      name: "Governance Templates",
      iconUrl: "corporate_decks.svg",
      description:
        "A governance template is a pre-written document used to create a governance framework for an organization or project",
      iconBGColor: "#E6FAF3",
      data: "Governance Templates",
    },
    {
      name: "Proposal Templates",
      iconUrl: "industries_decks.svg",
      description:
        "pre-written document that can be used to create a proposal for a product, service, or project.",
      iconBGColor: "#FFEFED",
      data: "Proposal Templates",
    },
    {
      name: 'Case Study Templates',
      iconUrl: 'Service_decks.svg',
      description: 'Case study templates typically include sections for outlining the background and context of the case study',
      iconBGColor: '#FDF8E8',
      data: 'Case Study Templates'

    },
    {
      name: "Delivery Quality Maturity Templates",
      iconUrl: "templates.svg",
      description:
        "Delivery Quality Maturity is a consolidation of key parameters assessing performance of multiple CIS functions and teams",
      iconBGColor: "#EFEFFD",
      data: "Delivery Quality Maturity Templates",
    },
  ];
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      
      {
        breakpoint: 1470,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1182,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          focusOnSelect: false,
          swipe: true,
        },
      },


      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
    ],
  };
  public ratinglist = [{
    name: "phanindra",
    comments: "No comments",
    rating: 4
  }]

  ngOnInit() {
    this.role = this.auth.getRole();
    this.empId =  parseInt(localStorage.getItem('Id'));
    this.useremail = this.auth.getEmailId();
    if (this.role.includes(GsdRoles.SuperAdmin) || this.role.includes(GsdRoles.Admin)) {
      this.superAdminAndAdmin = true;
     } 
     if (
      this.role.includes(GsdRoles.SuperAdmin) ||
      this.role.includes(GsdRoles.Admin) ||
      this.role.includes(GsdRoles.Leadership)
    ) {
      this.adminSuperAdminLeadership = true;
     } 
    this.getMostDownloadedTemplates();
    this.getMostRatedTemplates();
    this.getMostViewedTemplates();
    this.loading = true;
    this.getLatestUploadedDoc();
  }

  fetchRating(templates: any) {
    for (const templateId of templates) {
      this._service.GetRatingsByTemplateId(templateId.id).subscribe((res) => {
        this.ratings = res;
        templateId.ratings = this.ratings;
      });
    }
  }

  getLatestUploadedDoc(){
    this._service.getLatestUploaded(this.size,this.from).subscribe(res => {
      const uploadedDocuments = Object.assign([], res.sort((b, a) => new Date(a.uploadedDate).getTime() - new Date(b.uploadedDate).getTime()));
      this.uploadedDocuments = uploadedDocuments.slice(0, 9);
      this.uploadedDocumentsForTable = this.uploadedDocuments.slice(0, 5);
      this.cd.detectChanges();
      this.loading = false;
      this.getTemplatesForSideNav()
      this.defaultTemplatesLoad();
      this.loading = false;
    }, error => {
      this.uploadedDocuments = Object.assign([]);
      this.cd.detectChanges();
      this.loading = false;
    })
  }

  defaultTemplatesLoad(id?) {
    this.dataLoaded = true;
    this.templates = Object.assign([])
    this.cd.detectChanges();
    this._service.getAllTemplateCategories().subscribe(x => {
      this.templates = Object.assign([], x.data.items);
      this.dataLoaded = true;
      this.cd.detectChanges();
      if (localStorage.getItem("selectedTemplate")) {
        id = localStorage.getItem("selectedTemplate")
      }
      localStorage.setItem("selectedTemplate", "")
      this.selectedTemplate = Number(id)
      if (this.selectedTemplate) {
        this.getTemplatesById(this.selectedTemplate);
      }
    }, error => {
    })
    this.getserviceareas();
    this.getServiceLines();
    this.getTemplatesForSideNav();
  }
  getServiceLines(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._proposalService.getServiceLines().subscribe(x => {
        this.competency = x.data;
        if (x.data && Array.isArray(x.data)) {
          x.data.forEach(ser => {
            x = this.serviceLines.some(x => x.name == ser.name);
            if (!x) {
              this.serviceLines.push(ser);
            }
          });
        }
        this.loading = false;
        resolve(this.serviceLines);
      })
    });
  }
  getserviceareas(): Promise<any[]>{
    this.serviceLinesForDropDown = [];
    return new Promise((resolve, reject) => {
      this._proposalService.getServiceAreas().subscribe(x => {
        if (x.data && Array.isArray(x.data)) {
          x.data.forEach(tech => {
              this.serviceLinesForDropDown.push(
               tech
              );
          });
        }
      });
      resolve(this.serviceLinesForDropDown);
    })
  }

  downloadAllTemplate(selectedTemplates) {
    let templateIds = this.selectedDocsForDownload.map(i => i.id)
  
    this._service.downloadAllTemplate(templateIds).subscribe(data => {
      this.createZip(data.data, 'Templates');
      let resultData = data.data;
      for (let i = 0; i < resultData.length; i++) {
        this.downloadFile("", selectedTemplates[i].name);
      }
      setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
      this.templates.map(i => {
        if (i.id == this.selectedTemplate) {
          i.downloadCount = i.downloadCount + templateIds.length;
        }
      })
    });
  }

  async createZip(files: any[], zipName: string) {
    const zip = new JSZip();
    const name = zipName + '.zip';
    // tslint:disable-next-line:prefer-for-of  
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter].sharepointId;
      const fileData: any = await this._service.getFile(element);
      const b: any = new Blob([fileData], { type: fileData.type });
      zip.file(files[counter].name, b);
    }
    zip.generateAsync({ type: 'blob' }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
  }

  getSubTemplates(event) {
    this._proposalService.getSubTemplatesDropdown(this.selectedTemplate).subscribe((res) => {
      this.subTemplate = res.data;
    })
  }

  selectForDownload(event, data) {
    if (event.target.checked) {
      this.selectedDocsForDownload.push(data)
      this.canDownload = this.selectedDocsForDownload.length > 1 ? true : false;
      this.selectedTemplateCount++;
    } else {
      this.selectedDocsForDownload = this.selectedDocsForDownload.filter(sd => sd.id != data.id);
      this.canDownload = this.selectedDocsForDownload.length > 1 ? true : false;
      this.selectedTemplateCount--;
    }
  }

  isSelected(doc) {
    return this.selectedDocsForDownload.indexOf(doc) > -1 ? true : false
  }

  selectAllForDownload(event) {
    this.canDownload = event.target.checked;//event.target.checked;
    this.selectedDocsForDownload = this.canDownload ? this.currentDocuments : [];
    
  }

  clearSearchText() {
    this.searchText = '';
    this.clearSearch();
  }

  downloadSelectedTemplate() {
    this.selectedDocsForDownload.map(data => {
      this.downloadTemplate(data.id, data.sharepointId, data.name);
    })
  }

  backButtonClick() {
    this.router.navigate(['/Home']);
  }

  addTestTemplate() {
     //todo: write media queries for responsiveness
     const dialogRef = this.dialog.open(QuestionScanningComponent, {
      width: auto,
      height: auto,
      disableClose : true,
      panelClass: 'view-file',
      data: { categoryTypes: this.templates, title: "Add " },
    });
    if (window.innerWidth <= 600) {
      const dialogRef = this.dialog.open(QuestionScanningComponent, {
        width: '325px',
        maxWidth: '95vw',
        height: '60vh',
        disableClose : true,
        panelClass: 'view-file',
        data: { categoryTypes: this.templates, title: "Add " },
      });
    }
  }


  addTemplate() {
    //todo: write media queries for responsiveness
    const dialogRef = this.dialog.open(TemplateCreationComponent, {
      width: auto,
      height: auto,
      disableClose : true,
      panelClass: 'view-file',
      data: { categoryTypes: this.templates, title: "Add " },
    });
    
    if (window.innerWidth <= 600) {
      const dialogRef = this.dialog.open(TemplateCreationComponent, {
        width: '325px',
        maxWidth: '95vw',
        height: '60vh',
        disableClose : true,
        panelClass: 'view-file',
        data: { categoryTypes: this.templates, title: "Add " },
      });
    }
    dialogRef.afterClosed().subscribe(result => {
      var isArtifactoryCategoryAdded:boolean=false;
      this.templateService.isArtifactoryCategoryAdded.subscribe(res=>{
        isArtifactoryCategoryAdded=res;
      })
      //todo: temporary fix; need to refresh data only
      if(isArtifactoryCategoryAdded) {
        this.defaultTemplatesLoad();
      }
      if (result) {
        this.cd.detectChanges();
        this._service.AddTemplates(result).subscribe(res => {
          if (res) {
            this.templates.forEach(i => {
              let count = result.filter(item => item.templateId === i.id).length;
              if (count) {
                i.docCount += count;
              }
            });
            setTimeout(() => {
              this.getTemplatesById(this.selectedTemplate)
              if (this.artifactoryView === 'table') {
                this.getLatestUploadedDoc();
              }
            }, 1000);
            this.cd.detectChanges();
            this.toastr.success("Artifactories successfully added")
          }
        });
      }
    });
  }



  getTemplatesById(id: number) {
    this.getMostDownloadedTemplates();
    this._service.getLatestUploaded(this.size,this.from).subscribe(res => {
      this.loading=false
      this.uploadedDocuments = Object.assign([], res.sort((a, b) => new Date(b.uploadedDate).getTime() - new Date(a.uploadedDate).getTime())).slice(0, 9);
      this.cd.detectChanges();
    }, error => {
      this.uploadedDocuments = Object.assign([]);
      this.cd.detectChanges();
    });
    this.getMostRatedTemplates()
    this.getMostViewedTemplates()
    this. defaultTemplatesLoad();
    this.cd.detectChanges();
    this.selectedTemplate = id
    this.canDownload = false;
    const selectedTemplate = this.templates.find(({ id }) => id === this.selectedTemplate)
    this.selectedTemplateName = selectedTemplate && selectedTemplate.category ? selectedTemplate.category : [];
    this._service.getAllTemplatesById(id,this.docFrom,this.docSize).subscribe(res => {
      if (res.succeeded) {
        this.currentDocuments = Object.assign([], res.data.sort((a, b) => a.uploadedDate.localeCompare(b.uploadedDate)))
        this.getLatestUploadedDoc();
        this.cd.detectChanges();
      }
    }, error => {
      this.currentDocuments = Object.assign([]);
      this.cd.detectChanges();
    });
  }

  getLatestUploaded() {
    this._service.getLatestUploaded(this.size, this.from).subscribe(res => {
      this.uploadedDocuments = Object.assign([], res.sort((a, b) => new Date(b.uploadedDate).getTime() - new Date(a.uploadedDate).getTime()));
      this.cd.detectChanges();
    }, error => {
      this.uploadedDocuments = Object.assign([]);
      this.cd.detectChanges();
    });
  }

  onScroll(): void {
    let totalFiles = this.from
    this.from = this.uploadedDocuments.length;
    if (this.from != totalFiles){
      setTimeout(() => this._service.getLatestUploaded(this.size,this.from).subscribe(res => {
        let scrolledData = Object.assign([], res.sort((a, b) => a.name.localeCompare(b.name)))
        let uploadedIds = this.uploadedDocuments.map(x => x.id)
        for(var data of scrolledData)
        {
          if (uploadedIds.indexOf(data.id) == -1){
            this.uploadedDocuments = [...this.uploadedDocuments,data]
          }
        }
        }),1000)
    }
  };

  getMostDownloadedTemplates() {
    this._service.getMostDownloadedTemplates().subscribe(res => {
      this.mostDownloadedTemplates = res
    });
  }

  getMostRatedTemplates() {
    this.loading=true
    this._service.getMostRatedTemplates().subscribe(res => {
      this.loading=false
      this.mostRatedTemplates = res
    });
  }

  getMostViewedTemplates() {
    this.loading=true
    this._service.getMostViewedTemplates().subscribe(res => {
      this.mostViewedTemplates = res
      this.loading=false
      if (this.divClick && this.divClick.nativeElement) {
        this.divClick.nativeElement.click();
      }
    });
  }

  downloadTemplate(uuid, sharepointId, name) {
    this._service.downloadTemplate(uuid, sharepointId).subscribe(res => {
      var url = res.message
      this.downloadFile(url, name);
      if (this.showTemplates) {
        this.templates.map(i => {
          if (i.id == this.selectedTemplate) {
            i.downloadCount = i.downloadCount + 1;
          }
        })
        setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
      } else {
        setTimeout(() => this.searchButton(), 1000);
      }
    })
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  downloadFile(url, name) {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = String(name);
    a.click();
    a.remove();
  }

  clearSearch() {
    if (this.searchText == "") {
      this.searchButton();
    }
  }

  checkAllTokens() {
    this.searchTemplateModel.operator = !this.searchTemplateModel.operator;
  }

  searchButton() {
    if (this.searchText != "") {
      this.searchResultsViewFlag = true;
      this.showTemplates = true;
      this.searchTemplateModel.searchTerm = this.searchText
      this.searchTemplateModel.filterList = this.selected;
      this.loading=true
      this._service.SearchTemplates(this.searchTemplateModel).subscribe(res => {
        this.loading=false
        let result = res.data.templateResponse.items;       
        this.templateResponse = result;
        this.templateResponseForTable = result.slice(0, 5);
        this.templateModel = res.data.templateModel.items;
        let template = this.templates;
        
        this.cd.detectChanges();
      })
    }
    else {
      this.searchResultsViewFlag = false;
      this.showTemplates = false;
      this.currentDocuments = [];
      if (this.artifactoryView === 'table') {
        this.getLatestUploadedDoc();
      } else {
        this.defaultTemplatesLoad();
      }
    }
  }

  openUpdateTemplate(data, type) {
    if (data) {
      data = {
        values: [data],
        type: type
      };
    }
    else {
      data = {
        values: this.currentDocuments,
        type: type
      }
    }
    const dialogRef = this.dialog.open(UpdateTemplateModal, {
      width: '450px',
      height:auto,
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedDocsForDownload = [];
        
        this.cd.detectChanges();
        this.templates.forEach(i => {
          if (result.presentCategoryId == i.id) {
            i.downloadCount = i.downloadCount - result.downloadCount;
            i.docCount = i.docCount - result.foldersCount;
          }
          else if (result.newCategoryId == i.id) {
            i.downloadCount = i.downloadCount + result.downloadCount;
            i.docCount = i.docCount + result.foldersCount;
          }
        })
        this.cd.detectChanges();
        if (this.searchText) {
          setTimeout(() => this.searchButton(), 1000);
        }
        else {
          setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
        }
      }
      this.defaultTemplatesLoad();
    });
  }

  openEditTemplate(data) {
    if (!data.changesAllowed&&(this.auth.getEmailId()!=data.emailAddress)) {
      this.toastr.error("This Template cannot be edited");
      return;
    }
    data.title = "Edit "
    data.categoryTypes = this.templates
    data.serviceLinesForDropDown = this.serviceLinesForDropDown
    data.serviceLines = this.serviceLines
    const dialogRef = this.dialog.open(TemplateCreationComponent, {
      width: auto,
      height: auto,
      disableClose : true,
      panelClass: 'view-file',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cd.detectChanges();
        localStorage.setItem("selectedTemplate", this.selectedTemplate.toString())
        this._service.AddTemplates(result).subscribe(res => {
          this.toastr.success("Artifactory updated successfully")
          if (this.searchText) {
            setTimeout(() => this.searchButton(), 1000);
          } else {
            setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
          }
          })
      }
      this.defaultTemplatesLoad();
    })
  }

  openRatingTemplate(data) {
    this._service.GetRatingsByTemplateId(data.id).subscribe((res) => { 
      this.ratings = res
      this.useremail = this.auth.getEmailId();
      data.ratings = this.ratings;
      this.existingUser = data.ratings.find(item=>item.empId === this.empId);
      // data.ratings = this.ratings.filter(x => x.email == this.useremail)[0],
      data.name = data.fileName
      
      const dialogRef = this.dialog.open(RatingModalComponent, {
        width: auto,
        height: auto,
        data
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result)
        this.loading = true;
        //todo: temporary fix; need to refresh data only
        if (this.existingUser) {
          this._service.UpdateRating(result).subscribe(res => {
            this.loading=false;
            setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
            setTimeout(() => this.getMostRatedTemplates(), 1000);
            setTimeout(() => this.searchButton(), 1000);
            setTimeout(() => this.getLatestUploadedDoc(), 1000);
            this.cd.detectChanges();
            this.toastr.success("Rating Updated Successfully");
          });
        } else {
          this._service.AddRating(result).subscribe(res => {
            this.loading=false;
            setTimeout(() => this.getTemplatesById(this.selectedTemplate), 1000);
            setTimeout(() => this.getMostRatedTemplates(), 1000);
            setTimeout(() => this.getLatestUploadedDoc(), 1000);
            setTimeout(() => this.searchButton(), 1000);
            this.cd.detectChanges();
            this.toastr.success("Rating Added Successfully")
          })
          this.loading = false;
        }
      });
      this.loading = false;
    });
  }
  
  openReviews(data) {
    this._service.GetRatingsByTemplateId(data.id).subscribe((res) => {
      this.ratings = res;
      data.ratings = this.ratings
      
      if(this.ratings.length>=1) {
        const dialogRef = this.dialog.open(ViewReviewModalComponent, {
          width: '400px ',
          height: '400px',
          data
        });
        dialogRef.afterClosed().subscribe(result => {
          //todo: temporary fix; need to refresh data only
          if (result) {
            this._service.AddTemplateCategory(result).subscribe(res => {
            })
          }
        }); 
      }
    });
  }

  openDeleteTemplate(data, type) {
    data.categoryId=data.templateId
    if (data) {
      data = {
        values: [data],
        type: type,
        name:data.fileName
      };
    } else {
      data = {
        values: this.currentDocuments,
        type: type,
        name:data.fileName
      }
    }
    const dialogRef = this.dialog.open(DeleteTemplateModal, {
      width: auto,
      minWidth:'500px',
      height: auto,
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedDocsForDownload = [];
        this.cd.detectChanges();
        setTimeout(() => this.getTemplatesById(this.selectedTemplate), 2000);
        this.cd.detectChanges();
        this.toastr.success("Artifactory Deleted Successfully");

        if (this.searchText) {
          setTimeout(() => this.searchButton(), 1000);
        } else {
          if (data.values[0].id) {
            if(this.selectedTemplate) {
              this.templates[this.selectedTemplate - 1].docCount -= 1
              this.templates[this.selectedTemplate - 1].downloadCount -= data.values.reduce((total, doc) => total + doc.downloadCount, 0);
            }
          } else {
            this.templates[this.selectedTemplate - 1].docCount -= data.values[0].length;
            this.templates[this.selectedTemplate - 1].downloadCount -= data.values[0].reduce((total, doc) => total + doc.downloadCount, 0);
          }
         }
      }
      this.getLatestUploadedDoc();
    });
  }

  isAuthorizedUser(doc) {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Template.Admin') >= 0|| roles.indexOf('CompetencyLeader') >= 0|| roles.indexOf('SubCompetencyLeader') >= 0|| roles.indexOf('Leadership') >= 0||roles.indexOf('Admin')>=0)
      return true
    else {
      if (roles.indexOf('Template.User') >= 0) {
        if (doc.createdById.toString() == this.auth.getEmployeeId())
          return true;
      }
    }
    return false;
  }
  isAuthorizedforSelectAll() {
    var roles = this.auth.getRole();
    return roles.indexOf('Template.User') >= 0;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    $('#sidebar_r').removeClass('active');
    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
  }
  slickInit(e) {
    }
  breakpoint(e) {
   }
  afterChange(e) {
  }

  beforeChange(e) {
    }

  getTemplatesForSideNav() {

    this._proposalService.getTemplatesDropdown().subscribe((res) => {
      this.templatesForSideNav = res.data;
    })
  }


  dismissRightSidebar() {
    this.rightSideNav = false;
  }

  openRightSidebar() {
    this.rightSideNav = true;
    }

  doAction(template: any) {
    template.selected = !template.selected;
    if (template.selected) {
      this.selected.push(template.category);
    }
    else {
      this.selected.pop();
    }
  }

  selectUnselectAll() {
    this.selected = []
    this.checked = !this.checked;
    if (this.checked) {
      for (var template of this.templatesForSideNav) {
        template.selected = true
        this.selected.push(template.category)
      }
    } else {
      for (var template of this.templatesForSideNav) {
        template.selected =false;
      }
    }
  }

  viewFile(url,id) {
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { iFrameURL: url, Method: "Templates"},
    });
    dialogRef.afterClosed().subscribe(result =>
      {
        this.updateViewCount(id);

      })
  }

   updateViewCount(id){
     this._service.updateViewCount(id).subscribe(res => { 
      if(res){       
        setTimeout(() => this.getMostViewedTemplates(), 2000); 
      }
    }, error => {
      this.loading=false
    });
  }

  toggleView(option) {
    if (this.artifactoryView === option) {
      return;
    }
    this.artifactoryView = option;
    this.getLatestUploadedDoc();
  }

  getPaginatorData(event) {
    let from, size;
    if (event.previousPageIndex > event.pageIndex) {
      from = (event.pageIndex * 5);
      size = event.pageSize;
    } else {
      size = event.pageSize;
      from = (event.pageIndex * size);
    }
    if (this.searchResultsViewFlag) {
      this.templateResponseForTable = this.templateResponse.slice(from, from + size);
    } else {
      this.uploadedDocumentsForTable = this.uploadedDocuments.slice(from, from + size);
    }
  }

  exportToExcel() {
    if (this.uploadedDocuments.length > 0) {
      const exportData = this.uploadedDocuments.map((item) => {
        return {
          "Artifact Name": item.fileName,
          "Type": item.subCategoryTemplate,
          "Purpose": item.templateName,
          "Description": item.templateDescription,
          "Related Tags": item.templateTags.join(', '),
          "Contact Person": item.contactPerson,
        };
      });
      let fileName = 'Artifactories';
      this.excel.exportAsExcelFile(exportData, fileName);
    } else {
      this.toastr.error('No data available to export');
    }
  }
}
